import { RefactoredSpeechSynthesisService } from './refactoredSpeechSynthesisService';
import { DEFAULT_SPEECH_CONFIG } from './config';

export * from './types';
export * from './config';

export { TextSplitter } from './textSplitter';
export { AudioPlayer } from './audioPlayer';
export { ParallelTTSProcessor } from './parallelTTSProcessor';
export { QueueManager } from './queueManager';
export { RefactoredSpeechSynthesisService } from './refactoredSpeechSynthesisService';
export { SpeechSynthesisService } from '../speechSynthesisService';

export const refactoredSpeechSynthesisService = new RefactoredSpeechSynthesisService(
  DEFAULT_SPEECH_CONFIG
);
export { speechSynthesisService } from '../speechSynthesisService';
